import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const languages = ["en", "es", "fr"];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    whitelist: languages,

    debug: false,
    // backend: {
    //   loadPath: "/locales/{{lng}}/{{ns}}.json",
    //   allowMultiloading: true
    // },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
      allowMultiloading: true
    },

    interpolation: {
      escapeValue: false // not needed for react!!
    },

    react: {
      wait: true
    }
  });

export default i18n;
